export const SETTINGS_GET_LDAP = 'SETTINGS_GET_LDAP';
export const SETTINGS_SAVE_LDAP = 'SETTINGS_SAVE_LDAP';
export const SET_SETTINGS_LDAP_FIELD = 'SET_SETTINGS_LDAP_FIELD';
export const SETTINGS_LDAP_FAIL = 'SETTINGS_LDAP_FAIL';
export const SETTINGS_LDAP_RESET = 'SETTINGS_LDAP_RESET';
export const SETTINGS_LDAP_RESET_ERROR = 'SETTINGS_LDAP_RESET_ERROR';
